exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__all___2Lfhd {\n  width: 100%;\n  height: fit-content; }\n", ""]);

// exports
exports.locals = {
	"all": "styles__all___2Lfhd"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SearchControls/SearchGroups/SearchControl/styles.scss
// module id = 4209
// module chunks = 6